import AssessmentIcon from '@mui/icons-material/Assessment'
import AttachMoneyIcon from '@mui/icons-material/AttachMoney'
import Box from '@mui/material/Box'
import Fade from '@mui/material/Fade'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import I18n from 'i18n-js'
import PropTypes from 'prop-types'
import { useEffect } from 'react'
import { TransitionGroup } from 'react-transition-group'
import styled from 'styled-components'

import EcoIcon from '@src/svgs/Eco'

import {
  Breadcrumbs,
  Breadcrumb,
  BreadcrumbMenu,
} from '../../shared/Breadcrumbs'
import EnableInsights from '../EnableInsights'
import OrganicCampaignList from '../OrganicCampaignList'
import PremiumCampaignList from '../PremiumCampaignList'
import ReportingTabs from '../ReportingTabs'

const RelativeContainer = styled.div`
  position: relative;
`

const Reporting = (props) => {
  const { campaignType, retailerAccountSlug, brandSlug } = props.match.params
  useEffect(() => {
    if (!campaignType) {
      props.history.replace(
        `/retailer/reporting/${retailerAccountSlug}/${brandSlug}/organic`,
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  let children
  switch (campaignType) {
    case 'paid':
      children = <PremiumCampaignList />
      break
    default:
      children = <OrganicCampaignList />
      break
  }

  return (
    <Box p={6}>
      <Breadcrumbs pb={4} borderBottom="1px solid #ccc">
        <Breadcrumb
          Icon={AssessmentIcon}
          to={`/retailer/reporting/${retailerAccountSlug}/${brandSlug}/organic`}
        >
          {I18n.t('nav.reporting')}
        </Breadcrumb>
        <BreadcrumbMenu
          selected={campaignType}
          items={[
            {
              Icon: EcoIcon,
              label: I18n.t('shared.organic'),
              key: 'organic',
              to: `organic`,
            },
            {
              Icon: AttachMoneyIcon,
              label: I18n.t('shared.premium'),
              key: 'paid',
              to: `paid`,
            },
          ]}
        />
      </Breadcrumbs>
      <Typography style={{ padding: '16px 0' }} variant="h5">
        {I18n.t('nav.reporting')}
      </Typography>
      <EnableInsights />
      <Grid alignItems="center" container>
        <Grid item md={11} xs={10}>
          <ReportingTabs params={props.match.params} value={campaignType} />
        </Grid>
      </Grid>
      <RelativeContainer>
        <TransitionGroup>
          <Fade in={true} key={campaignType}>
            <Box
              bgcolor="background.paper"
              //padding={2}
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                marginTop: '24px',
              }}
            >
              {children}
            </Box>
          </Fade>
        </TransitionGroup>
      </RelativeContainer>
    </Box>
  )
}

Reporting.propTypes = {
  history: PropTypes.object,
  match: PropTypes.object,
}

export default Reporting
